module.exports = __webpack_public_path__ + "bin/9cbc70a7fdfbf0aa83817223612340d2.svg";